import { ChangeEvent, SyntheticEvent } from 'react';
import { useFormContext } from 'react-hook-form';
import { z } from 'zod';
import { UnicodeEntity } from '@mews/enums';
import { ChipInput } from '@mews/b2b-ui';
import { useLocalizeText, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { SendReminderFormValues } from '../schema';

const emailSchema = z.string().email();

export const RecipientsChipInput = ({ name, ...props }: { name: string }) => {
    const localizeText = useLocalizeText();
    const {
        setValue,
        watch,
        setError,
        clearErrors,
        formState: { errors },
    } = useFormContext<SendReminderFormValues>();
    const emails = watch('emails') || [];

    const handleChange = (_e: ChangeEvent<HTMLInputElement> | SyntheticEvent, newValue: string[]) => {
        const invalid = newValue.filter((email) => !emailSchema.safeParse(email).success);

        setValue('emails', newValue);

        if (invalid.length > 0) {
            setError('emails', {
                type: 'manual',
                message: localizeText({
                    textKey: TextKey.SendReminderRecipientsInvalidEmailErrorMessage,
                    substitutes: { emails: invalid.join(', ') },
                }),
            });
        } else {
            clearErrors('emails');
        }
    };

    return (
        <ChipInput
            {...props}
            name={name}
            size="medium"
            delimiters={[UnicodeEntity.Comma, UnicodeEntity.Space]}
            value={emails}
            onChange={handleChange}
            error={errors.emails ? lt(errors.emails?.message as TextKey) : null}
        />
    );
};
